import ko from 'knockout';
import _ from 'lodash';
import moment from 'moment-timezone';
import templateMarkup from 'raw-loader!./historical2-capacity-view.html';
import LogiCommon from '../../../app/data-framework/logi-common';
import PreferenceService from '../../../services/preference.service';
import LoginService from "../../../services/login.service";

function HistoricalCapacity2View(params) {
    var self = this;
    var loaded = false;
    var link = params.route().link;
    self.appId = 'historical2';

    self.panels = ko.observableArray([]);
    self.fixedPanels = ko.observableArray([]);

    self.widgetDragDropContainerOptions = {};
    self.dataProvider = params.dataProvider;
    self.dataProvider.loadFlexQueryMetadata();
    self.dataProvider.loadSystems();
    self.dataProvider.loadEndpointModels();

    self.route = params.route;
    self.menus = params.menus;
    self.currentTabFixedPanelObservable = ko.observableArray([]);
    self.currentPanelsObservable = ko.observableArray([]);
    self.subscriptions = [];

    self.tabId = ko.pureComputed(function() {
      return self.route().tabId ? self.route().tabId.toString() : '0';
    });

    self.timeZone = { id: _.get(LoginService.userObject, 'timezoneId', ''), text: _.get(LoginService.userObject, 'timezoneDisplay', '') };
    self.logiCommon = new LogiCommon();

    self.selectedDateRangeValues = ko.observable();
    function handleRoute()  {
        self.urlParams = self.route().params ? self.logiCommon.getParamsObject(self.route().params) : null;
        
        if (!link) {
            PreferenceService.getDateRange(self.appId).then((dateRange) => {
                self.selectedDateRangeValues({
                    startDate: moment(dateRange.startDate),
                    endDate: moment(dateRange.endDate)
                });
                loaded = true;
                self.selectedDateRangeValues.valueHasMutated();
            });
        } else {
            self.dataProvider.getTokenParams(link).then(function (tokenParams) {
                if (tokenParams) {
                    self.selectedDateRangeValues({
                        startDate: moment(tokenParams.inpStartDate, 'YYYY/MM/DD'),
                        endDate: moment(tokenParams.inpEndDate, 'YYYY/MM/DD')
                    });
                } else {
                    alert('Invalid link');
                }
                loaded = true;
                self.selectedDateRangeValues.valueHasMutated();
            });
        }
    }

    handleRoute();
    self.subscriptions.push(self.route.subscribe(()=> handleRoute()));

    self.viewLevelOptions = ko.pureComputed(function () {
        //hierarchy, daterange, urlparamobject, dataFilter, daysPerWeek, hoursPerDay
        var result = self.logiCommon.GetHistoricalViewLevelOptions2(null, self.selectedDateRangeValues(), self.urlParams);
        if (loaded && result.inpStartDate) {
            result.isCapacityView = true;
            return result;
        }
        return null;
    }).extend({ notify: 'always' });

    self.subscriptions.push(self.viewLevelOptions.subscribe(function () {
        if (self.urlParams || !loaded || link) {
            return;
        }
        PreferenceService.saveDateRange('historical2', self.selectedDateRangeValues());
    }));
}

// This runs when the component is torn down. Put here any logic necessary to clean up,
// for example cancelling setTimeouts or disposing Knockout subscriptions/computeds.
HistoricalCapacity2View.prototype.dispose = function () {
    var self = this;
    self.subscriptions.forEach(function (sub) {
        sub.dispose();
    });
};

export default { viewModel: HistoricalCapacity2View, template: templateMarkup };
